import type { FC, ReactNode } from 'react';

export const EmptyLayout: FC<{ children?: ReactNode }> = ({ children }) => (
  <>{children}</>
);
